import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/fix-google-ads-wasted-spend-colorado")!;

export const Route = createFileRoute("/learn/fix-google-ads-wasted-spend-colorado")({
  head: () => seoHead("/learn/fix-google-ads-wasted-spend-colorado", "How to fix wasted Google Ads spend for Colorado businesses", "Common Google Ads problems that waste money \u2014 wrong locations, broad keywords, missing negatives, poor tracking \u2014 and how to fix them.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
